import React from 'react';
import {
  View, Text, StyleSheet, FlexStyle,
} from 'react-native';
import isMobile from './IsMobile';
import Colors from '../constants/Colors';
import ResolvedIconMobile from './16pxIcons/ResolvedIconMobile';
import ResolvedIcon from './ResolvedIcon';

interface SuccessMessageProps {
  title: string,
  style?: FlexStyle,
  testID?: string,
}

const SuccessMessage = ({
  title, style, testID,
}: SuccessMessageProps) => <View
  style={[styles.container, style]}
  {...{ testID }}
>
    <View style={styles.iconContainer}>
      {isMobile ? <ResolvedIconMobile /> : <ResolvedIcon />}
    </View>
    <Text style={styles.title}>{title}</Text>
  </View>;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    alignItems: 'center',
    paddingTop: isMobile ? 120 : undefined,
    paddingBottom: isMobile ? 40 : undefined,
  },
  title: {
    marginTop: isMobile ? 24 : 32,
    fontSize: isMobile ? 20 : 28,
    lineHeight: isMobile ? 24 : 34,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksGreen400,
    textAlign: 'center',
  },
  iconContainer: {
    width: isMobile ? 40 : 64,
    height: isMobile ? 40 : 64,
    borderRadius: isMobile ? 20 : 32,
    backgroundColor: Colors.light.hereworksGreen400,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default SuccessMessage;
